import React from 'react';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
const bonuses = [{
  id: 'B1',
  title: 'Banco de Rutinas Anti-Rumiación',
  desc: 'Ejercicios mentales pre-armados enfocados en destrabar tu mente cuando entra en bucle.'
}, {
  id: 'B2',
  title: 'Guía de Desintoxicación Dopaminérgica',
  desc: 'El paso a paso para limpiar tu cerebro del exceso de estímulos digitales y pantallas.'
}, {
  id: 'B3',
  title: 'Entrenamientos de Emergencia Mental de 5 min',
  desc: 'Acciones de choque de aplicación inmediata para cuando sentís que la ansiedad se dispara.'
}, {
  id: 'B4',
  title: 'Diseñador de Entornos Calmos',
  desc: 'Cómo organizar tu espacio de trabajo y descanso para reducir la carga cognitiva gastando cero pesos.'
}, {
  id: 'B5',
  title: 'Protocolo de Higiene de Sueño Profundo',
  desc: 'Preparación detallada para apagar el cerebro a la noche y despertarte con energía real, no con alerta.'
}, {
  id: 'B6',
  title: 'Rastreador de Disciplina Emocional',
  desc: 'Planillas listas para registrar tus disparadores de ansiedad y medir tu progreso diario.'
}];
export function Bonuses() {
  return <section className="py-24 md:py-32 px-6 bg-charcoal text-cream" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <FadeIn className="text-center mb-16 md:mb-24" data-id="element-15">
          <div className="inline-flex items-center gap-3 mb-4" data-id="element-16">
            <span className="text-3xl" data-id="element-17">🎁</span>
            <h2 className="text-2xl md:text-4xl font-serif" data-id="element-18">
              INCLUIDOS GRATIS: 6 BONOS ESTRATÉGICOS
            </h2>
          </div>
          <p className="text-cream/60 uppercase tracking-widest text-sm" data-id="element-19">
            (Sin costo extra — Incluidos únicamente comprando hoy)
          </p>
        </FadeIn>

        <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mb-20" data-id="element-20">
          {bonuses.map(bonus => <StaggerItem key={bonus.id} data-id="element-21">
              <div className="h-full border border-white/10 p-8 hover:border-terracotta/50 transition-colors duration-300 bg-white/[0.02]" data-id="element-22">
                <div className="text-terracotta font-serif text-xl mb-4" data-id="element-23">
                  {bonus.id}
                </div>
                <h3 className="text-xl font-medium mb-4 leading-snug" data-id="element-24">
                  {bonus.title}{' '}
                  <span className="text-terracotta text-sm align-top ml-1" data-id="element-25">
                    (GRATIS)
                  </span>
                </h3>
                <p className="text-cream/60 font-light leading-relaxed" data-id="element-26">
                  {bonus.desc}
                </p>
              </div>
            </StaggerItem>)}
        </StaggerContainer>

        <FadeIn delay={0.2} className="text-center" data-id="element-27">
          <div className="inline-block border border-terracotta/30 bg-terracotta/5 px-8 py-6" data-id="element-28">
            <p className="text-xl md:text-3xl font-serif" data-id="element-29">
              💰 VALOR TOTAL DE LOS BONOS:{' '}
              <span className="line-through text-cream/40" data-id="element-30">$56.000</span> ➔{' '}
              <span className="text-terracotta font-bold" data-id="element-31">¡GRATIS HOY!</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}